import request from '../request'

const bannerApi = {}

// 获取banner图片列表
bannerApi.getBannerList = (param) => {
  return request({
    url: '/function/banner/list',
    method: 'GET',
    params: param
  })
}

// 新增banner管理
bannerApi.addBannerManage = param => {
  return request({
    url: '/function/banner',
    method: 'POST',
    data: param
  })
}

// 删除banner管理
bannerApi.deleteBannerManage = param => {
  return request({
    url: '/function/banner/remove',
    method: 'POST',
    data: param
  })
}

// 置顶一条banner
bannerApi.toTopSetting = param => {
  return request({
    url: '/function/banner/setTopOne',
    method: 'GET',
    params: param
  })
}

// 根据ID查详情
bannerApi.getBannerDetailByID = param => {
  return request({
    url: '/function/banner',
    method: 'GET',
    params: param
  })
}

// 更新banner管理
bannerApi.upDateBannerManager = param => {
  return request({
    url: '/function/banner',
    method: 'PUT',
    data: param
  })
}

// 上传接口
bannerApi.upLoadData = param => {
  return request({
    url: '/common/upload',
    method: 'POST',
    data: param
  })
}

// 根据类型获取数据字典列表

bannerApi.getDictList = () => {
  return request({
    url: '/system/dict/data/type',
    method: 'GET'
  })
}

export default bannerApi
